"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reporter = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var event_tracking_behavior_v4_1 = require("@al/event-tracking-behavior-v4");
event_tracking_core_1.container.load(event_tracking_behavior_v4_1.v4Dependencies);
var Reporter = /** @class */ (function () {
    function Reporter() {
        var tempV3Service = {
            // @ts-expect-error v3暂时占位
            init: event_tracking_core_1.noop,
            setSdkConfig: event_tracking_core_1.noop,
            updateSdkConfig: event_tracking_core_1.noop,
            setPageConfig: event_tracking_core_1.noop,
            // @ts-expect-error v3暂时占位
            getPageConfig: event_tracking_core_1.noop,
            enter: event_tracking_core_1.noop,
            leave: event_tracking_core_1.noop,
            click: event_tracking_core_1.noop,
            expose: event_tracking_core_1.noop,
            input: event_tracking_core_1.noop,
            enableAutoExpose: event_tracking_core_1.noop,
            stopExposeMonitor: event_tracking_core_1.noop,
            reCollectExposeItems: event_tracking_core_1.noop,
            exposeAfterReCollect: event_tracking_core_1.noop,
        };
        this.tracker = {
            v3: tempV3Service,
            v4: this._v4Service,
        };
        this._v3Service = tempV3Service;
    }
    Reporter.prototype.processReportData = function (data) {
        if (!data) {
            return;
        }
        var v3 = data.v3, v4 = data.v4, rest = __rest(data, ["v3", "v4"]);
        var result = {};
        if (v3) {
            result.v3 = __assign(__assign({}, rest), v3);
        }
        if (v4) {
            result.v4 = __assign(__assign({}, rest), v4);
        }
        return result;
    };
    Reporter.prototype.invoke = function (methodKey, data) {
        var _this = this;
        var extra = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extra[_i - 2] = arguments[_i];
        }
        var result = {};
        if (!data) {
            return result;
        }
        Object.keys(data).forEach(function (key) {
            var _a;
            var c = data[key];
            if (c && _this.tracker[key]) {
                // TODO: 处理类型
                // @ts-expect-error 类型问题
                result[key] = (_a = _this.tracker[key])[methodKey].apply(_a, __spreadArray([c], extra, false));
            }
        });
        return result;
    };
    Reporter.prototype.init = function (config) {
        this.invoke("init", config);
    };
    Reporter.prototype.setSdkConfig = function (config) {
        this.invoke("setSdkConfig", config);
    };
    Reporter.prototype.updateSdkConfig = function (config) {
        this.invoke("updateSdkConfig", config);
    };
    Reporter.prototype.setPageConfig = function (config) {
        this.invoke("setPageConfig", config);
    };
    Reporter.prototype.getPageConfig = function () {
        return this.invoke("getPageConfig", {
            v3: {},
            v4: {},
        });
    };
    Reporter.prototype.enter = function (data) {
        this.invoke("enter", this.processReportData(data));
    };
    Reporter.prototype.leave = function (data) {
        this.invoke("leave", this.processReportData(data));
    };
    Reporter.prototype.click = function (data, event) {
        this.invoke("click", this.processReportData(data), event);
    };
    Reporter.prototype.popClick = function (data, event) {
        this.invoke("popClick", this.processReportData(data), event);
    };
    Reporter.prototype.expose = function (data) {
        this.invoke("expose", this.processReportData(data));
    };
    Reporter.prototype.input = function (data) {
        this.invoke("input", this.processReportData(data));
    };
    // enableAutoExpose(data?: IReportData): void {
    //   this.invoke("enableAutoExpose", this.processReportData(data));
    // }
    // stopExposeMonitor(data?: IReportData): void {
    //   this.invoke("stopExposeMonitor", this.processReportData(data));
    // }
    // reCollectExposeItems(data?: IReportData): void {
    //   this.invoke("reCollectExposeItems", this.processReportData(data));
    // }
    // exposeAfterReCollect(data?: IExposeAfterReCollectConfig): void {
    //   this.invoke("exposeAfterReCollect", this.processReportData(data));
    // }
    Reporter.prototype.subscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    Reporter.prototype.unsubscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    __decorate([
        (0, event_tracking_core_1.lazyInject)(event_tracking_behavior_v4_1.TYPES.V4ReportService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "_v4Service", void 0);
    __decorate([
        (0, event_tracking_core_1.lazyInject)(event_tracking_core_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], Reporter.prototype, "observableService", void 0);
    Reporter = __decorate([
        (0, inversify_1.injectable)(),
        __metadata("design:paramtypes", [])
    ], Reporter);
    return Reporter;
}());
exports.Reporter = Reporter;
